import React from 'react'

export default function Footer() {
  return (
		<div className="footer">
			<div>
				<a href="http://github.com/VSSSP">
				<img src="https://icongr.am/devicon/github-original.svg?size=60&color=d2d6dd" alt="gitHub"/>
				</a>
				<a href="https://www.linkedin.com/in/victorssspaula/">
				<img src="https://icongr.am/devicon/linkedin-plain.svg?size=60&color=d2d6dd" alt="Linkedin"/>
				</a>
			</div>
			<spam>Victor de Paula - 2022</spam>
		</div>
  )
}
